import { render, staticRenderFns } from "./row-inputs.vue?vue&type=template&id=b95fd38a&scoped=true&"
import script from "./row-inputs.vue?vue&type=script&lang=ts&"
export * from "./row-inputs.vue?vue&type=script&lang=ts&"
import style0 from "./row-inputs.vue?vue&type=style&index=0&id=b95fd38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95fd38a",
  null
  
)

export default component.exports